import React, {Component} from 'react';
import {translate} from 'react-i18next';
import moment from 'moment';
import swal from 'sweetalert';
import { Table} from 'react-bootstrap';
import RaisedButton from 'material-ui/RaisedButton';
import SvgIcon from 'react-icons-kit';
import {print} from 'react-icons-kit/fa/print';
import ModalReport from '../../patient/petition_register/modalReport';

var Config = require('../../../config');

class DespatchProducts extends Component{
	constructor(props){
		super(props);

		this.getLotes = this.getLotes.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onCancel = this.onCancel.bind(this);
		this.getProducts = this.getProducts.bind(this);
		this.selectCopies = this.selectCopies.bind(this);

		this.state = {
			table_reserve:[],
			solicited_products:[],
			date:"",
			hour:"",

			no_file:"",
			patient:"",
			group_rh:"",
		}

	}

	componentDidMount(){
		var id = this.props.match.params.id;


		fetch(Config.default.apiGateway.URL+'unit_delivered/by_petition?id='+id+'&hf_id='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				this.setState({
					no_file:response.expedient,
					patient:response.patient_name,
					group_rh: response.patient_group+(
							response.patient_rh === 'POSITIVO' ? '+' :
							response.patient_rh === 'NEGATIVO' ? '-' : '')
				})
			}
		});	

		this.getProducts(id);

		//fecha y hora
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);
			var aux_date = new Date();

			this.setState({
				date : moment(aux[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
				hour:hours,
			});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getProducts(id){
		fetch(Config.default.apiGateway.URL+'petitions/get_products/'+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined ){
				var products = [];
				response.map((res)=>{
					res.pending = res.amount;
					res.send_amount = 0;
					res.reserved = 0;
					res.lote_selected = "";
					res.id_product = "";
					res.lotes = [];
					res.dates = [];
					res.lotes_envio = [];
				})
				this.setState({solicited_products:response});

				setTimeout(()=>{
					this.getLotes();
					
				}, 500);
				
			}
		});	
	}

	getLotes(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product/stock/'+
			sessionStorage.getItem('health_facilities_id'), {
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			//this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				var lotes = [];
				response.map((res, i)=>{
					var index = this.state.solicited_products.findIndex(obj => 
						obj.name === res.product.name
					)
					if(index !== -1){
						res.stock.map((s)=>{
							this.state.solicited_products[index].id_product = res.product.id;
							this.state.solicited_products[index].lotes.push({
								lote:s.lot_number,
								total: s.total,
								disabled:false,
							});

						})
					}
						
				})
				
				this.forceUpdate();

				setTimeout(()=>{
					this.getSavedProducts(this.props.match.params.id);
				}, 500)
				
			}
		});
	}

	getSavedProducts(id){
		//this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'plasmatic_product_export/petition_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined && response !== null){
				var cantidad = 0, pendiente = 0;

				response.map((res)=>{
					var index = this.state.solicited_products.findIndex(obj => 
						obj.plasmatic_product_id === res.product.id
					);

					var cant_devolution = 0;
					res.devolutions.map((d)=>{
						cant_devolution += d.amount;
					})

					if(index !== -1){
						var total = res.export.amount - cant_devolution;
						this.state.solicited_products[index].send_amount += total;

						var pending = this.state.solicited_products[index].amount - this.state.solicited_products[index].send_amount
						this.state.solicited_products[index].pending = pending < 0 ? 0 : pending;

						this.state.solicited_products[index].lotes_envio.push({lote:res.export.lot_number});

						this.state.solicited_products[index].dates.push({ex_date:moment(res.expiration_date).format("DD/MM/YYYY")});
					}

				});

				this.forceUpdate();
			}
		});	
	}

	onSave(){

		var obj = {
			petition_id:this.props.match.params.id,
			date:moment(this.state.date, 'YYYY-MM-DD').format('MM-DD-YYYY'),
			hour:moment(this.state.hour, 'HH:mm').format('H:mm:ss'),
			products:[]
		}

		this.state.solicited_products.map((s)=>{
			if((s.reserved !== "" && s.reserved !== undefined) && s.lote_selected !== ""){
				obj.products.push({
					product_id:s.id_product,
					lot_number:s.lote_selected,
					amount:s.reserved,
				})
			}
				
		})

		if(obj.products.length > 0){
			this.props.waiting.handleShow('Guardando...');
			fetch(Config.default.apiGateway.URL+'plasmatic_product_export/'+
				sessionStorage.getItem('health_facilities_id'),{
				method: 'post',
				body: JSON.stringify(obj),
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(function(result) {
						swal('¡Error!', result, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					swal('Proceso Terminado', 'El envio se realizó correctamente', 'success');
					//this.props.history.push('/petition_register');
					this.getProducts(this.props.match.params.id);
					//window.location.reload();
				}
			})
		}else{
			swal('Error', 'Debe llenar los campos', 'error');
		}
			
	}

	onCancel(){
		if(this.props.location.state !== undefined){
			if(this.props.location.state.from === 'patient_search'){
				this.props.history.push('/patient_search/'+this.props.location.state.patient_id);
			}
		}else{
			this.props.history.push("/petition_register");
		}
		
	}

  	handleChange(e){
  		var campo = e.target.id.split('_');
  		var id = parseInt(campo[1]);
  		var pos = parseInt(campo[2]);
  		var index = -1;
  		var valor = e.target.value;

  		index = this.state.solicited_products.findIndex(obj => 
			obj.id_product === id
		);
  		if(campo[0] === 'prod'){
  			if(index !== -1){
  				if(valor !== '-1'){
  					//this.state.solicited_products[index].amount_received = parseInt(valor);
  					this.state.solicited_products[index].reserved = parseInt(valor);
  				}else{
  					swal('Error', 'No se permiten numeros negativos', 'error');
  					document.getElementById('prod_'+id+'_'+pos).value = '';
	  					
  				}
  				
  				this.forceUpdate();
  			}
		  }
		  
  		if(campo[0] === 'lot'){
  			var cantidad_disponible = parseInt(e.target.options[e.target.selectedIndex].getAttribute('cantidad'));

  			if(index !== -1){
  				var cantidad_solicitada = this.state.solicited_products[index].amount;
  				var cantidad = this.state.solicited_products[index].reserved;
  				
  				if(cantidad > cantidad_disponible){
  					swal({
				        title: '¿Está seguro?',
				        text: 'El lote que selecciono cuenta con '+cantidad_disponible+' unidades disponibles, desea continuar?',
				        type: 'warning',
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Continuar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true
				    }, (isConfirm)=>{
				        if (isConfirm) {
				        	this.state.solicited_products[index].reserved = cantidad_disponible;
				        	this.state.solicited_products[index].lote_selected 	 = valor;


				        	var lot = this.state.solicited_products[index].lotes.findIndex(obj => 
				        		obj.lote === valor
				        	)

							if(lot !== -1){
								this.state.solicited_products[index].lotes[lot].disabled = true;
							}

							var pending = this.state.solicited_products[index].pending - cantidad_disponible

				        	this.state.solicited_products.push({
				        		amount: this.state.solicited_products[index].amount,
								id: this.state.solicited_products[index].id,
								id_product: this.state.solicited_products[index].id_product,
								lote_selected: "",
								lotes: this.state.solicited_products[index].lotes,
								lotes_envio:[],
								name: this.state.solicited_products[index].name,
								pending: pending < 0 ? 0 : pending,
								plasmatic_product_id: this.state.solicited_products[index].plasmatic_product_id,
								reserved: 0,
								send_amount: this.state.solicited_products[index].send_amount
				        	});

				        	this.forceUpdate();

				        	document.getElementById('prod_'+id+'_'+pos).value = cantidad_disponible;					        	
				        	document.getElementById('prod_'+id+'_'+pos).disabled = true;
				        	document.getElementById('lot_'+id+'_'+pos).disabled = true;

				        	if(document.getElementById('prod_'+id+'_'+(pos+1)) !== null){
				        		document.getElementById('prod_'+id+'_'+(pos+1)).focus();	
				        	}
				        	

	  							
				        }else{
				        	document.getElementById('lot_'+id+'_'+pos).value = "";
				        }
				    }); 					
  				}else if(cantidad <= cantidad_disponible){
  					var reserve = parseInt(document.getElementById('prod_'+id+'_'+pos).value);
  					this.state.solicited_products[pos].lote_selected 	 = valor;
  					this.state.solicited_products[pos].reserved = reserve;
  					this.forceUpdate();

  				}
  				
  			}
  		}
  	}

  	async printReport(e){
		e.preventDefault();

		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = this.props.match.params.id;
		obj.file_type = "p_plasmatic_delivered";
		obj.nEtiqueta = [0];

		this.props.waiting.handleShow('Imprimiendo...');

		var type = await this.props.getDocumentType(obj.file_type);

		this.props.waiting.handleClose();
		if(type !== undefined){
			var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
		}
	}

	selectCopies(){
		console.log(this)
		this.modal_report.handleShow([], 'p_plasmatic_delivered')
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Envio de Productos
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right"}}>
							<span className="span-min">Número de Expediente</span>
						</div>
						<div className="col-xs-12 col-sm-9">
							<span style={{color:"var(--base1)"}}>{this.state.no_file}</span>
						</div>
					</div>
					<div className="col-xs-12">
						<div className="col-xs-12 col-sm-2" style={{textAlign:"right", marginTop:"10px"}}>
							<span className="span-min">Nombre de Paciente</span>
						</div>
						<div className="col-xs-12 col-sm-6">
							<span style={{color:"var(--base1)", marginRight:"20px"}}>{this.state.patient}</span>

							<span style={{color:"red", fontWeight:"bold", fontSize:"25px"}}>{this.state.group_rh}</span>
						</div>
					</div>

					<fieldset className="col-xs-12">
	        			<legend>Productos solicitados</legend>
	        			<div className="col-xs-12 col-sm-6 col-sm-offset-3">
	        				
	        				<Table responsive hover>
	        					<thead>
	        						<tr>
	        							<th>Producto</th>
	        							<th>Solicitada</th>
	        							<th>Enviada</th>
	        							<th>Lote Envio</th>
										<th>Caducidad</th>
	        							<th>Pendiente</th>
	        							<th style={{width:'12%'}}>Cantidad</th>
	        							<th>Lote</th>
	        						</tr>
	        					</thead>
	        					<tbody>
	        						{this.state.solicited_products.map((s, i)=>(
	        							
        								<tr key={i}>
											<td>{s.name}</td>
											<td>{s.amount}</td>
											<td>{s.send_amount}</td>
											<td>
												{s.lotes_envio.map((l, j)=>(
													<div key={j}><span>{l.lote}</span></div>
												))}
											</td>
											<td>
												{s.dates.map((l, j)=>(
													<div key={j}><span>{l.ex_date}</span></div>
												))}
											</td>
											<td>{s.pending}</td>
											<td>
												<input type="number" className="form-control hour-input" min='0' 
													id={"prod_"+s.id_product+'_'+i} onChange={this.handleChange} />
											</td>
											<td>
												<select className="form-control" id={"lot_"+s.id_product+'_'+i} onChange={this.handleChange}>
													<option value="">Seleccione...</option>
													{s.lotes.map((l, j)=>(
														<option key={j} value={l.lote} cantidad={l.total} disabled={l.disabled}>
															{l.lote}
														</option>
													))}
												</select>
												
											</td>
										</tr>
										
									))}
	        					</tbody>
	        				</Table>
	        			</div>
	        		</fieldset>

	        		<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
						<button className="toolIcon" 
							onClick={(e)=>this.selectCopies(e)}>
							<SvgIcon size={40} icon={print} />
							<div className="col-xs-12">
								<span>Imprimir</span>
							</div>
						</button>
					</div>

	        		<div className="col-xs-12" style={{textAlign:'center'}}>
				        	
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} 
		        			onClick={this.onSave}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} 
		        			onClick={this.onCancel}/>
			        	
			        </div>

				</form>
		
				<ModalReport {...this.props} onRef={ref => this.modal_report = ref} />
			</div>
		)
	}
}

export default translate('translations')(DespatchProducts);
